import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useCallback, useMemo, useState } from 'react';
import { registerRemoveOverlay } from '../pm-plugins/actions';
import { AwarenessWrapper } from '../ui/AwarenessWrapper';
import { InlineCard } from './inlineCard';
export var InlineCardWithAwareness = /*#__PURE__*/memo(function (_ref) {
  var node = _ref.node,
    cardContext = _ref.cardContext,
    actionOptions = _ref.actionOptions,
    useAlternativePreloader = _ref.useAlternativePreloader,
    view = _ref.view,
    getPos = _ref.getPos,
    pluginInjectionApi = _ref.pluginInjectionApi,
    onClick = _ref.onClick,
    isPulseEnabled = _ref.isPulseEnabled,
    isOverlayEnabled = _ref.isOverlayEnabled,
    isSelected = _ref.isSelected;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isInserted = _useState4[0],
    setIsInserted = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isResolvedViewRendered = _useState6[0],
    setIsResolvedViewRendered = _useState6[1];
  var onResolve = useCallback(function (tr, title) {
    registerRemoveOverlay(function () {
      return setIsInserted(false);
    })(tr);
    if (title) {
      setIsResolvedViewRendered(true);
    }
  }, []);
  var markMostRecentlyInsertedLink = useCallback(function (isLinkMostRecentlyInserted) {
    if (isOverlayEnabled) {
      setIsInserted(isLinkMostRecentlyInserted);
    }
  }, [isOverlayEnabled]);
  var setOverlayHoveredStyles = useCallback(function (isHovered) {
    if (isOverlayEnabled) {
      setIsHovered(isHovered);
    }
  }, [isOverlayEnabled]);
  var innerCard = useMemo(function () {
    return /*#__PURE__*/React.createElement(InlineCard, {
      node: node,
      view: view,
      getPos: getPos,
      useAlternativePreloader: useAlternativePreloader,
      actionOptions: actionOptions,
      onResolve: onResolve,
      onClick: onClick,
      cardContext: cardContext,
      isHovered: isHovered
    });
  }, [actionOptions, cardContext, getPos, isHovered, node, onClick, onResolve, useAlternativePreloader, view]);
  return isOverlayEnabled || isPulseEnabled ? /*#__PURE__*/React.createElement(AwarenessWrapper, {
    isOverlayEnabled: isOverlayEnabled,
    isPulseEnabled: isPulseEnabled,
    cardContext: cardContext,
    getPos: getPos,
    isHovered: isHovered,
    isInserted: isInserted,
    url: node.attrs.url,
    isSelected: isSelected,
    isResolvedViewRendered: isResolvedViewRendered,
    markMostRecentlyInsertedLink: markMostRecentlyInsertedLink,
    pluginInjectionApi: pluginInjectionApi,
    setOverlayHoveredStyles: setOverlayHoveredStyles
  }, innerCard) :
  /*#__PURE__*/
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  React.createElement("span", {
    className: "card"
  }, innerCard);
});